import React from 'react';
import styles from './../../../../styles/sass/components/ProductTourModal.module.scss';

interface Props {
  totalIndices: number;
  currentIndex: number;
  goToPage: Function;
}

const PaginationDots: React.FC<Props> = ({
  totalIndices,
  currentIndex,
  goToPage,
}) => {
  return (
    <div className={styles.paginationContainer}>
      <div className={styles.pagination}>
        {[...Array(totalIndices)].map((_: any, current: number) => {
          return (
            <span
              key={current}
              className={`${styles.dot}
                ${current <= currentIndex ? styles.active : styles.regular}`}
              onClick={() => goToPage(current)}
            ></span>
          );
        })}
      </div>
    </div>
  );
};

export default PaginationDots;
